import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

const Container = styled.div`
  background: ${props => (props.dark ? props.theme.colors.amexGrisFondo : '#fff')};
`

const Wrapper = styled.div`
  padding: ${props => (props.borderTop ? '10px 40px' : '40px')};
  border-top: ${props =>
    props.borderTop ? `1px solid ${props.theme.colors.amexGrisFondo}` : '0'};

  ${breakpoint('desktop')`
    margin: 0 auto;
    max-width: 1000px;
    padding-left: 0;
    padding-right: 0;
  `}
`

const Contenedor = ({ children, dark, borderTop }) => (
  <Container dark={dark}>
    <Wrapper borderTop={borderTop}>{children}</Wrapper>
  </Container>
)

export default Contenedor
